var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrightness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.005,
    height: 33.005,
    viewBox: "0 0 33.005 33.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.541,111.292a9.332,9.332,0,1,0,8.365,9.282A9.429,9.429,0,0,0,121.541,111.292Zm0,16.616V113.239a7.4,7.4,0,0,1,0,14.669Zm0,0",
    transform: "translate(-104.071 -104.071)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M241.967,5.772a.967.967,0,0,0,.967-.967V.967a.967.967,0,1,0-1.934,0V4.805A.967.967,0,0,0,241.967,5.772Zm0,0",
    transform: "translate(-225.465 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M241.967,422.457a.967.967,0,0,0-.967.967v3.838a.967.967,0,0,0,1.934,0v-3.838A.967.967,0,0,0,241.967,422.457Zm0,0",
    transform: "translate(-225.465 -395.224)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.772,241.967A.967.967,0,0,0,4.805,241H.967a.967.967,0,1,0,0,1.934H4.805A.967.967,0,0,0,5.772,241.967Zm0,0",
    transform: "translate(0 -225.465)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M427.262,241h-3.838a.967.967,0,1,0,0,1.934h3.838a.967.967,0,1,0,0-1.934Zm0,0",
    transform: "translate(-395.224 -225.465)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.878,70.246a.967.967,0,0,0,1.367-1.367l-2.79-2.79a.967.967,0,0,0-1.367,1.367Zm0,0",
    transform: "translate(-61.563 -61.563)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M374.563,373.193a.967.967,0,0,0-1.367,1.367l2.79,2.79a.967.967,0,0,0,1.367-1.367Zm0,0",
    transform: "translate(-348.874 -348.871)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.881,373.193l-2.79,2.79a.967.967,0,1,0,1.367,1.367l2.79-2.79a.967.967,0,1,0-1.367-1.367Zm0,0",
    transform: "translate(-61.566 -348.871)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M373.877,70.529a.964.964,0,0,0,.684-.283l2.79-2.79a.967.967,0,0,0-1.367-1.367l-2.79,2.79a.967.967,0,0,0,.684,1.651Zm0,0",
    transform: "translate(-348.871 -61.563)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrightness);
export default __webpack_public_path__ + "static/media/brightness.1b4a8bd10587f766f82ce74f7b68b3ec.svg";
export { ForwardRef as ReactComponent };